var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spin-stage"},[_c('a-spin',{staticClass:"loadSpin",attrs:{"tip":"Carregando..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }